// PUBLIC TEMPLATES — the module's public face.
//
// Split on 2026-07-27 (SP-TEMPLATES): this file was 866 lines, by far the
// largest in the package. It now owns only the re-exports and the load-time
// re-validation guard; the schemas/resolvers live in templateSchema.ts and
// the hand-authored template data in templateData.ts. Every name that used
// to be importable from "./templates.js" still is, so no consumer moved.
//
// This is also the one place that legitimately needs BOTH halves as runtime
// values (the schemas, to parse; the data, to be parsed) — which is why the
// guard lives here and not in either half. templateData imports templateSchema
// type-only, so those two have no runtime edge and cannot form a cycle.

export * from "./templateSchema.js";
export * from "./templateData.js";

import { PlanTemplate, ProgramTemplate } from "./templateSchema.js";
import { PUBLIC_PLAN_TEMPLATES, PUBLIC_PROGRAM_TEMPLATES } from "./templateData.js";

// ─── Re-validation guard ───────────────────────────────────────────────
//
// Templates are written by hand; a typo in a slug or a percentage out
// of range would only surface at runtime parse time. Running the Zod
// schemas at module load gives us a typecheck-time + import-time safety
// net for free. If a template ever fails to parse the build / typecheck
// will not catch it (Zod runs at runtime), but the first import path
// throws loudly and the user sees no templates instead of a corrupt
// shape. Cheap insurance for a 4-template static set.
for (const tpl of PUBLIC_PLAN_TEMPLATES) {
  PlanTemplate.parse(tpl);
}
for (const tpl of PUBLIC_PROGRAM_TEMPLATES) {
  ProgramTemplate.parse(tpl);
}
